import { authAxios } from './axiosInstance';

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
export const analyticsService = {
    async getAnalytics(period: string = 'month') {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/analytics/garage/${garageId}?period=${period}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des analytiques:', error);
            throw error;
        }
    },

    async getInvoices() {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/quotes/invoices/garage/${garageId}`);
            console.log("invoices",response);
            return response;
        } catch (error) {
            console.error('Erreur lors de la récupération des analytiques:', error);
            throw error;
        }
    },
    async downloadInvoicesPDF(invoiceId: string) {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/quotes/invoices/${invoiceId}/download`, {
                responseType: 'blob'
            });

            return response;
        } catch (error) {
            console.error('Erreur lors de la récupération des analytiques:', error);
            throw error;
        }
    },
    async getFinances(period: string = 'all') {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/analytics/garage/${garageId}/finances?period=${period}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des finances:', error);
            throw error;
        }
    }
};